"use client";

export default function V6CTA() {
  return (
    <section className="py-24 md:py-32 px-6 bg-white border-t border-hairline/60">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-3xl md:text-4xl font-bold tracking-[-0.02em] text-ink">
          Sit one yourself
        </h2>
        <p className="mt-4 text-ink-soft leading-relaxed">
          The examiner asks out loud and flies the scenario with you, drills the parts you
          leave thin, and tells you at the end which areas would have passed. You answer by
          voice, or type if you&rsquo;d rather.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row gap-3 justify-center">
          <a href="/oral" className="pill pill-accent">
            Take the oral
          </a>
          <a href="#conversation" className="pill pill-quiet">
            Re-read the exam
          </a>
        </div>
      </div>
    </section>
  );
}
